export default __webpack_public_path__ + "static/media/img-32-sorgin.e69bd422.jpg";